import React, { useEffect, useState, useMemo } from "react";
import community_img from "../../../images/Community-Image.webp";
import { useDispatch, useSelector } from "react-redux";
import { fetchGroupData } from "../../../Services/Community/CommunityAPI/communityApi";
import { capitalizeWords } from "../../../Utils/LetterCase";
import { useNavigate } from "react-router-dom";
import { encryptId } from "../../../Utils/Crypto";
import PaginationComponent from "./pagination";

const LargeCommunityDirectory = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchQuery, setSearchQuery] = useState("");
    const [showDropDown, setShowDropDown] = useState(false);
    const [id, setId] = useState("")
    const [isSelected, setIsSelected] = useState(false)
    const [page, setPage] = useState(1);
    const [count, setCount] = useState();
    const [hasMounted, setHasMounted] = useState(false);
    const { data } = useSelector((state) => state.fetchGroupData);

    const defaultGroup = data?.data?.default;

    const filteredData = useMemo(() => {
        if (!data?.data?.data) return [];

        if (id) {
            return data.data.data.filter(group => group.id === id);
        }

        return data.data.data.filter(group => group.name.toLowerCase() === defaultGroup?.name?.toLowerCase());
    }, [data?.data?.data, defaultGroup?.name, id]);

    useEffect(() => {
        dispatch(fetchGroupData({ group_name: searchQuery, page_number: page }));
    }, [page, searchQuery]); // Runs only once on mount

    useEffect(() => {
        if (!hasMounted || !searchQuery.trim() || isSelected) return;

        const delaySearch = setTimeout(() => {
            dispatch(fetchGroupData({ group_name: searchQuery, page_number: page }));
        }, 500);

        return () => clearTimeout(delaySearch);
    }, [searchQuery, page, dispatch, hasMounted, isSelected]);


    useEffect(() => {
        if (searchQuery?.length > 0 && searchQuery !== defaultGroup && !isSelected) setShowDropDown(true)
        if (isSelected) setShowDropDown(false)
    }, [defaultGroup, isSelected, searchQuery])

    const handleSelect = (group) => {
        setIsSelected(true)
        setId(group?.id)
        setSearchQuery(group?.name)
        if (searchQuery.toLowerCase() === group?.name.toLowerCase()) setShowDropDown(false);
        setCount(group?.communities?.count)
    };

    useEffect(() => {
        if (!data?.data?.data?.length || hasMounted) return;

        if (defaultGroup && !isSelected) {
            setId(defaultGroup.id);
            setSearchQuery(defaultGroup.name);
            setCount(data?.data?.default_group_community_count || 0);
            setIsSelected(true);
            setHasMounted(true); // Mark as initialized
        }
    }, [data, defaultGroup, isSelected, hasMounted]);

    const highlightMatch = (suggestion, query) => {
        const startIndex = suggestion?.toLowerCase()?.indexOf(query?.toLowerCase());
        if (startIndex === -1) return suggestion;

        const endIndex = startIndex + query.length;
        return (
            <>
                {suggestion.slice(0, startIndex)}
                <span
                    style={{
                        // textDecoration: 'underline',
                        textDecorationColor: '#dd483b', // Underline color (Orange)
                        textDecorationThickness: '2px', // Thicker underline
                        textUnderlineOffset: '4px', // Space between the text and underline
                        transition: 'all 0.3s ease', // Smooth transition for hover
                        fontWeight: 'normal', // Reduce font weight for highlighted text
                    }}
                >
                    {suggestion.slice(startIndex, endIndex)}
                </span>
                {suggestion.slice(endIndex)}
            </>
        );
    };

    return (
        <div className="container mt-4">
            <h3 className="text-center fw-semibold">Large Community Directory</h3>
            <div className="inner-searchbar mb-5 mt-3 community_directory">
                <div className="input-searchbar loader-block">
                    <input
                        className="px-4 w-75 community-dir-searchbar"
                        type="text"
                        name="q"
                        id="community"
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                            setIsSelected(false);
                        }}
                        placeholder="Search by Community Name"
                    />
                    <div
                        className={`searchbar-content-info-block suggestions w-75 ${showDropDown ? "visible" : ""
                            }`}
                    >

                        <div className="content-inner-wrapper">
                            {data?.data?.data?.map((group) => (
                                <div className="content-wrapper-box" key={group?.id}>
                                    <div
                                        className="main-content-block d-flex justify-content-between border-b-2 border-gray-500 py-1"
                                        onClick={() => handleSelect(group)}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div className="community-name-block">
                                            {highlightMatch(
                                                capitalizeWords(group?.name),
                                                searchQuery
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {filteredData?.length > 0 && filteredData[0]?.communities?.data?.length > 0 && (
                    filteredData[0]?.communities?.data?.map((item, index) => (
                        <div className="col-12 col-sm-3 text-center" key={item?.community?.id}>
                            <div
                                onClick={() =>
                                    navigate(`/tab/${encryptId(item?.community?.id)}`)
                                }
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={item?.community?.image || community_img}
                                    alt={item.title}
                                    className="img-fluid rounded"
                                />
                                <p className="mt-2">{capitalizeWords(item?.community?.name)}</p>
                            </div>
                        </div>
                    )))}
            </div>
            {filteredData?.length > 0 && count > 8 && (
                <div className="d-flex justify-content-center">
                    <PaginationComponent
                        count={count}
                        page={page}
                        setPage={setPage}
                    />
                </div>
            )}
        </div>
    );
};

export default LargeCommunityDirectory;
